import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { materialBusiness } from "api/bussiness/material/material-bussiness";
import { invalidateMaterialCatalogCache } from "api/cached";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { IUpdateMaterial } from "mobx-stores/_models/material-inventory/material";
import { useStores } from "mobx-stores/_root-store";
import { useCallback } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getUpdateMaterialSchema } from "./schema";

export const UpdateMaterial = observer(() => {
  const queryClient = useQueryClient();
  const {
    materialStore: { openEdit, getMaterials, materialDetail, setProp },
  } = useStores();
  const {
    form: { controls, isValid },
    submitHandler,
  } = useForm<IUpdateMaterial>(getUpdateMaterialSchema(), {
    id: materialDetail?.id,
    code: materialDetail?.code,
    barcode: materialDetail?.barcode,
    name: materialDetail?.name,
    specificationLength: materialDetail?.specificationLength,
    specificationSize: materialDetail?.specificationSize,
    specificationThick: materialDetail?.specificationThick,
    type: materialDetail?.type,
    allowedInventory: materialDetail?.allowedInventory,
  });

  const saveHandler = useCallback(
    async (data: IUpdateMaterial) => {
      try {
        if (!materialDetail?.id) return;
        await materialBusiness.update(materialDetail?.id, data);
        await invalidateMaterialCatalogCache(queryClient);
        await getMaterials();
        setProp("openEdit", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [materialDetail?.id, getMaterials, queryClient, setProp],
  );

  return (
    <DialogForm
      open={openEdit}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa vật tư </DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
